import { useEffect } from 'react'
import type { Dispatch } from 'react'
import { validateResetPasswordToken } from '../../../customerAuthApi'
import type { ResetPasswordFlowAction } from './ResetPasswordFlow.types'

export const readResetPasswordTokenFromQuery = (search: string): string =>
  new URLSearchParams(search).get('token')?.trim() ?? ''

type UseResetPasswordFlowEffectsInput = {
  dispatch: Dispatch<ResetPasswordFlowAction>
}

export const useResetPasswordFlowEffects = ({ dispatch }: UseResetPasswordFlowEffectsInput) => {
  useEffect(() => {
    if (typeof window === 'undefined') return

    const token = readResetPasswordTokenFromQuery(window.location.search)
    dispatch({ type: 'INIT_FROM_QUERY', token })

    if (!token) return

    let cancelled = false

    void validateResetPasswordToken(token)
      .then((response) => {
        if (cancelled) return
        dispatch({ type: 'TOKEN_VALIDATION_RESOLVED', status: response.status })
      })
      .catch(() => {
        if (cancelled) return
        dispatch({ type: 'TOKEN_VALIDATION_FAILED' })
      })

    return () => {
      cancelled = true
    }
  }, [dispatch])
}
